<template>
    <div class="row" id="intro">
        <div class="col-12">
            <p>After 50 incredible years, the time has come for the British Airways Brass Band to take its final bow.</p>
<p>From concert halls to community events, parades to competitions, it has been an honour to share our music and passion with so many people over the decades. The band has been more than just a group of musicians — it has been a family, built on friendship, dedication, and a shared love of brass music.</p>
<p>We are immensely proud of everything we’ve achieved together and deeply grateful for the unwavering support from our audiences, supporters, friends, and families over the years.</p>
<p>While this chapter closes, the memories, music, and friendships will carry on long after the final note.</p>
<p>Thank you for being part of our journey. </p>
        </div>
    </div>
</template>

<script>
import {store} from '../../store.js';

export default {
    name: 'IntroRow',
    data: function() {
        return {
            store
        }
    }
}
</script>
